import { Link } from 'react-router-dom';

import ArrowLeftIcon from '../../icons/arrow-left';

import './styles/page-header.css';

export default function PageHeader({ eyebrow, title, description, backTo, backLabel = 'Volver', actions, meta }) {
    return (
        <header className="page-header">
            {backTo && (
                <Link to={backTo} className="page-header__back">
                    <ArrowLeftIcon size={18} />
                    <span>{backLabel}</span>
                </Link>
            )}
            {eyebrow && <p className="page-header__eyebrow">{eyebrow}</p>}
            <div className="page-header__row">
                <h1 className="page-header__title">{title}</h1>
                {actions && <div className="page-header__actions">{actions}</div>}
            </div>
            {description && <p className="page-header__description">{description}</p>}
            {meta && <div className="page-header__meta">{meta}</div>}
        </header>
    );
}
